import { Reducer } from 'redux'

import { PropostaTypes, PropostaState } from './types'

const INITIAL_STATE: PropostaState = {
  loadingProposta: false,
  dadosProposta: {
    numeroParcelas: 0,
    valorParcela: '',
    taxa: '',
    cet: '',
    percentualIOF: '',
    valorIOF: '',
    valorLiberado: '',
    total: '',
    primeiroDesconto: '',
    ultimoDesconto: '',
    taxaNominalContrato: '',
    taxaNominalAnual: '',
    jurosContratadosPercentual: '',
    jurosContratados: '',
    valorTotalDestinadoPagamentoSeguro: '',
    percentualPropostaSeguroPrestamista: '',
    tarifaCadastro: '',
    taxaTarifaCadastro: '',
    valorSolicitado: '',
    valorSolicitadoPercentual: '',
    valorOperacao: '',
    valorDoMutuo: '',
    atributosCetMensal: '',
    atributosCetAnual: '',
    dataNascimento: '',
    nomeMae: '',
    valorTotalASerPago: '',
    quantidadeDeParcelas: 0,
    matricula: '',
    tipoLiberacao: '',
    jurosCapitalizados: true,
    estipulante: '',
    possuiSeguro: false,
    dataEmissao: '',
    enderecoResidencial: '',
    cidadeResidencial: '',
    estadoResidencial: '',
    bairroResidencial: '',
    numeroResidencial: '',
    nomeCliente: '',
    cpf: '',
    nomeConjuge: '',
    banco: '',
    agencia: '',
    conta: '',
    nomePai: '',
    cidadeNaturalidade: '',
    estadoNaturalidade: '',
    estadoCivil: '',
    nacionalidade: '',
    documentoIdentificacao: '',
    taxaEfetivaMensal: '',
    taxaEfetivaAnual: '',
    orgao: '',
    complementoResidencial: '',
    cepResidencial: '',
    cepResidencialComMascara: '',
    dddCelular: '',
    telefoneCelular: '',
    codigoContratoOriginalPortabilidade: '',
    bancoPortadoDescricao: '',
    digitoContaCorrente: '',
    profissao: '',
    escolaridade: '',
    contratosRefin: [],
    saldoDevedorTotalRefin: '',
    email: '',
    valorDaParcela: '',
    convenio: '',
    vencimentoPrimeiraParcela: '',
    cnpjFinanceiraCredorPortabilidade: '',
    prazoPortabilidade: '',
    cnpjLojaMaster: '',
    vlrTotalDevedor: '',
    valorSaldoDevedorPortabilidade: '',
  },
  dadosPropostaAntiga: {
    numeroParcelas: 0,
    valorParcela: '',
    taxa: '',
    cet: '',
    percentualIOF: '',
    valorIOF: '',
    valorLiberado: '',
    total: '',
    primeiroDesconto: '',
    ultimoDesconto: '',
    taxaNominalContrato: '',
    taxaNominalAnual: '',
    jurosContratadosPercentual: '',
    jurosContratados: '',
    valorTotalDestinadoPagamentoSeguro: '',
    percentualPropostaSeguroPrestamista: '',
    tarifaCadastro: '',
    taxaTarifaCadastro: '',
    valorSolicitado: '',
    valorSolicitadoPercentual: '',
    valorOperacao: '',
    valorDoMutuo: '',
    atributosCetMensal: '',
    atributosCetAnual: '',
    dataNascimento: '',
    nomeMae: '',
    valorTotalASerPago: '',
    quantidadeDeParcelas: 0,
    matricula: '',
    tipoLiberacao: '',
    jurosCapitalizados: true,
    estipulante: '',
    possuiSeguro: false,
    dataEmissao: '',
    enderecoResidencial: '',
    cidadeResidencial: '',
    estadoResidencial: '',
    bairroResidencial: '',
    numeroResidencial: '',
    nomeCliente: '',
    cpf: '',
    nomeConjuge: '',
    banco: '',
    agencia: '',
    conta: '',
    nomePai: '',
    cidadeNaturalidade: '',
    estadoNaturalidade: '',
    estadoCivil: '',
    nacionalidade: '',
    documentoIdentificacao: '',
    taxaEfetivaMensal: '',
    taxaEfetivaAnual: '',
    orgao: '',
    complementoResidencial: '',
    cepResidencial: '',
    cepResidencialComMascara: '',
    dddCelular: '',
    telefoneCelular: '',
    codigoContratoOriginalPortabilidade: '',
    bancoPortadoDescricao: '',
    digitoContaCorrente: '',
    profissao: '',
    escolaridade: '',
    contratosRefin: [],
    saldoDevedorTotalRefin: '',
    email: '',
    valorDaParcela: '',
    convenio: '',
    vencimentoPrimeiraParcela: '',
    cnpjFinanceiraCredorPortabilidade: '',
    prazoPortabilidade: '',
    cnpjLojaMaster: '',
    vlrTotalDevedor: '',
    valorSaldoDevedorPortabilidade: '',
  },
  dadosPropostaError: false,

  numeroProposta: undefined,
  tipoDocumento: undefined,
  idIteracao: '',

  loadingSalvarProposta: false,
  propostaEnviada: false,
  erroSalvarProposta: false,
}

const reducer: Reducer<PropostaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PropostaTypes.DADOS_PROPOSTA_REQUEST:
      return { ...state, loadingProposta: true }
    case PropostaTypes.DADOS_PROPOSTA_SUCCESS:
      return {
        ...state,
        dadosProposta: action.payload,
        dadosPropostaError: false,
        loadingProposta: false,
      }
    case PropostaTypes.DADOS_PROPOSTA_ERROR:
      return { ...state, dadosPropostaError: true, loadingProposta: false }
    case PropostaTypes.SET_ID_ITERACAO:
      return { ...state, idIteracao: action.payload }
    case PropostaTypes.SET_TIPO_DOCUMENTO:
      return { ...state, tipoDocumento: action.payload }
    case PropostaTypes.DADOS_PROPOSTA_ANTIGA_REQUEST:
      return { ...state, loadingProposta: true }
    case PropostaTypes.DADOS_PROPOSTA_ANTIGA_SUCCESS:
      return {
        ...state,
        dadosPropostaAntiga: action.payload,
        dadosPropostaError: false,
        loadingProposta: false,
      }
    case PropostaTypes.DADOS_PROPOSTA_ANTIGA_ERROR:
      return { ...state, dadosPropostaError: true, loadingProposta: false }

    case PropostaTypes.GET_PROPOSTAS_REQUEST:
      return { ...state, loadingProposta: true }
    case PropostaTypes.GET_PROPOSTAS_SUCCESS:
      return {
        ...state,
        numeroProposta: action.payload.proposals?.[0]?.proposal,
        loadingProposta: false,
      }
    case PropostaTypes.GET_PROPOSTAS_ERROR:
      return { ...state, loadingProposta: false }
    case PropostaTypes.RESET:
      return { ...INITIAL_STATE }
    default:
      return state
  }
}

export default reducer
